import React from 'react';
import { Router } from '@reach/router';
import { StylesProvider, ThemeProvider as MaterialThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import MaterialTheme from '../styles/MaterialTheme';
import StyledGlobal from '../styles/StyledGlobal';

import Index from './Index';
import Photos from './Photos';
import Size from './Size';
import BatteryLife from './BatteryLife';

import AppStyles from './App.styles';

const Root: React.FC = () => (
  <StylesProvider injectFirst>
    <StyledThemeProvider theme={MaterialTheme}>
      <MaterialThemeProvider theme={MaterialTheme}>
        <CssBaseline />
        <StyledGlobal />

        <AppStyles>
          <Router>
            <Index path="/" />
            <Photos path="/photos" />
            <Size path="/size" />
            <BatteryLife path="/battery" />
          </Router>
        </AppStyles>
      </MaterialThemeProvider>
    </StyledThemeProvider>
  </StylesProvider>
);

export default Root;
